import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
const d2dPillUrl = 'frontend/user-config-d2d-pill/';
export default class HeroPillAPI {
    static addDayToDayPill(accessParams, pill) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + d2dPillUrl, pill, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static editDayToDayPill(accessParams, pill) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .put(accessParams.API_ENDPOINT + d2dPillUrl, pill, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
    static removeDayToDayPill(accessParams, slot) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .delete(accessParams.API_ENDPOINT + d2dPillUrl + `?slot=${slot}`, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map